import React from "react";
import "./TermsOfUse.css";
import PageHeader from "./layout/PageHeader";

const TermsOfUse = ({
  activeLocation,
  locations = [],
  onChangeLocation,
  companyDisplayName,
  currentUser,
  onLogout,
  onLock,
}) => {
  return (
    <div className="terms-of-use-container page-shell">
      <PageHeader
        title="Terms of Use"
        subtitle="Unity Global Care / ALBERTai legal terms."
        icon={<span style={{ fontWeight: 800, fontSize: "18px" }}>ⓘ</span>}
        activeLocation={activeLocation}
        locations={locations}
        onChangeLocation={onChangeLocation}
        companyDisplayName={companyDisplayName}
        currentUser={currentUser}
        onLogout={onLogout}
        onLock={onLock}
      />

      <div
        className="tou-header"
        style={{
          textAlign: "center",
          marginBottom: "24px",
          padding: "0 8px",
        }}
      >
        <h1>TERMS OF USE</h1>
        <h2>UNITY GLOBAL CARE INC.</h2>
        <h2>ALBERTai</h2>
      </div>

      <div
        className="tou-content"
        style={{
          padding: "32px",
          maxWidth: "900px",
          margin: "0 auto",
          color: "#333",
          lineHeight: "1.6",
          background: "#fff",
          borderRadius: "12px",
          border: "1px solid #e5e7eb",
          boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
        }}
      >
        <h3>Terms of Service</h3>
        <p>
          <strong>Effective Date: December 4, 2025</strong>
        </p>

        <p>
          This website in whole or in part is strictly a health and wellness
          decision support tool and is in no way a substitute for medical,
          health or wellness advice or treatment from a licensed medical
          professional. If you are not feeling well, call 911 immediately and
          seek help from a trained and licensed medical professional. This
          website also contains news and information about health, wellness, and
          Unity Global Care® products and services in addition to information
          from Unity Global Care® partners. It does not provide medical advice,
          diagnosis, or treatment information. This content is not intended to
          be a substitute for professional medical advice, diagnosis, or
          treatment.
        </p>

        <p>
          Always seek the advice of your physician or other qualified health
          provider with any questions you may have regarding a medical
          condition. Never disregard professional medical advice or delay in
          seeking it because of something you have read on this website.
        </p>

        <p>
          This website is operated by Unity Global Care Inc. doing business as
          “ALBERTai®“, a Delaware corporation (and any affiliates or
          subsidiaries). Throughout the site, the terms “we”, “us” and “our”
          refer to ALBERTai®. ALBERTai® offers this website, including all
          information, applications, tools, devices, products, and services
          available from this site and other sites operated by us (collectively,
          the “Services” and defined below) to you, the user, conditioned upon
          your acceptance of all terms, conditions, policies, and notices stated
          here.
        </p>

        <p>
          By visiting our sites and/or purchasing anything from us, you engage
          in the use of our “Services” (“Services” shall mean any service
          provided to you by us whether through the use of this website or any
          other form) and you agree to be bound by the terms and conditions in
          these Terms of Service (“Terms of Service”, “Terms”), including those
          additional terms and conditions and policies referenced herein. These
          Terms of Service apply to all consumers or users of any of the
          Services (which term shall include without limitation the ALBERTai®
          Companion app, the ALBERTai® website and networking application/tool
          related thereto, the electronic device used to access the Services and
          ALBERTai® software running in the device, the network or elsewhere as
          well as other services and products that may be used by us from time
          to time). The term “consumers or users of any Services” includes,
          without limitation, users who are browsers, vendors, customers,
          merchants, and/or contributors of content.
        </p>

        <p>
          Please read these Terms of Service carefully before accessing or using
          our website or Services. By accessing or using any part of our site,
          you agree to be bound by these Terms of Service. If you do not agree
          to all the Terms of Service, then you may not access the website or
          use any Services. Acceptance of the use of any Services is conditioned
          upon acceptance of these Terms of Service.
        </p>

        <p>
          Any new features or tools that are added to the current site or
          Services shall also be subject to the Terms of Service. You can review
          the most current version of the Terms of Service at any time on this
          page or as established elsewhere on our website. We reserve the right
          to update, change, or replace any part of these Terms of Service by
          posting updates and/or changes to our website. It is your
          responsibility to check this page and our website periodically for
          changes. Your continued use of or access to the website or Services
          following the posting of any changes constitutes acceptance of those
          changes.
        </p>

        <h3>SECTION 1 – ONLINE SERVICE TERMS</h3>
        <p>
          By agreeing to these Terms of Service, you represent that you are at
          least the age of majority in your state or province of residence, and
          you have given us your consent to allow any of your minor dependents
          to use this site.
        </p>
        <p>
          You may not use our products for any illegal or unauthorized purpose
          nor may you, in the use of the Services, violate any laws, including
          but not limited to, any laws in your jurisdiction (including but not
          limited to copyright laws). Any information you provide shall be
          truthful, and accurate and shall not improperly disclose any
          information about any individual or entity in violation of any
          applicable laws, copyright laws, or any other laws or requirements
          providing privacy, confidentiality, or property rights of any nature
          or description. You are solely responsible for any information you
          provide. Moreover, there is no guarantee that any information you
          provide or attempt to provide will be reviewed by us. We are not
          responsible for any delay in responding to you.
        </p>
        <p>
          You must not transmit any worms, viruses, malware, or any code of a
          destructive nature, or otherwise transmit, knowingly or unknowingly,
          anything that is harmful to the Services.
        </p>
        <p>
          A breach or violation of any of the Terms will result in the immediate
          termination of your Services.
        </p>

        <h3>SECTION 2 – GENERAL CONDITIONS</h3>
        <p>
          We reserve the right to refuse Services to anyone for any reason at
          any time, provided that such refusal does not violate any applicable
          laws. If you believe that any decision to refuse Services was
          inappropriate, please contact info@goalbertai.com.
        </p>
        <p>
          You agree not to reproduce, duplicate, copy, sell, resell, or exploit
          any portion of the Services, use of the Services, or access to the
          Services or any contact on the website through which the Services are
          provided, without express written permission by us.
        </p>

        <h3>SECTION 3 – PERSONAL INFORMATION</h3>
        <p>
          Your submission of personal information is governed by our Privacy
          Policy. To view our Privacy Policy, go to{" "}
          <a
            href="https://www.goalbertai.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.goalbertai.com/privacy
          </a>
          .
        </p>

        <h3>SECTION 4 – ALBERTai® USER CONTENT, PHOTO, VIDEO DISCLOSURE</h3>
        <p>
          ALBERTai® recommends that all content, photos, and videos sent and
          shared by users be legal and appropriate only. Personal Identifiable
          Information is not recommended or intended to be used by the ALBERTai®
          product.
        </p>

        <h3>SECTION 5 – MODIFICATIONS TO THE SERVICES AND PRICES</h3>
        <p>
          Prices for our products are subject to change. We will make every
          effort to inform you of these changes, however, we shall not be liable
          if we cannot reach you.
        </p>
        <p>
          We reserve the right at any time to modify or discontinue the Services
          (or any part or content thereof) without notice. We shall not be
          liable to you or to any third party for any modification, price
          change, suspension, or discontinuance of the Services.
        </p>

        <h3>SECTION 6 – ERRORS, INACCURACIES, AND OMISSIONS</h3>
        <p>
          Occasionally, there may be information on our site or in the Services
          that contains typographical errors, inaccuracies, or omissions that
          may relate to product descriptions, pricing, promotions, offers,
          product shipping charges, transit times, and availability. We reserve
          the right to correct any errors, inaccuracies, or omissions, and to
          change or update information or cancel orders if any information in
          the Services or on any related website is inaccurate at any time
          without prior notice (including after you have submitted your order).
        </p>
        <p>
          We undertake no obligation to update, amend, or clarify information in
          the Services or on any related website, including, without limitation,
          pricing information, except as required by law. No specified update or
          refresh date applied in the Services or on any related website should
          be taken to indicate that all information in the Services or on any
          related website has been modified or updated.
        </p>

        <h3>SECTION 7 – PROHIBITED USES</h3>
        <p>
          In addition to other prohibitions as set forth in the Terms of
          Service, you are prohibited from using the site or its content: (a)
          for any unlawful purpose; (b) to solicit others to perform or
          participate in any unlawful acts; (c) to violate any international,
          federal, provincial or state regulations, rules, laws, or local
          ordinances; (d) to infringe upon or violate our intellectual property
          rights or the intellectual property rights of others; (e) to harass,
          abuse, insult, harm, defame, slander, disparage, intimidate, or
          discriminate based on gender, sexual orientation, religion, ethnicity,
          race, age, national origin, or disability; (f) to submit false or
          misleading information; (g) to upload or transmit viruses or any other
          type of malicious code that will or may be used in any way that will
          affect the functionality or operation of the Services or of any
          related website, other websites, or the Internet; (h) to collect or
          track the personal information of others; (i) to spam, phish, pharm,
          pretext, spider, crawl, or scrape; (j) for any obscene or immoral
          purpose; or (k) to interfere with or circumvent the security features
          of the Services or any related website, other websites, or the
          Internet. We reserve the right to terminate your use of the Services
          or any related website for violating any of the prohibited uses.
        </p>

        <h3>SECTION 8 – DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY</h3>
        <p>
          We do not guarantee, represent, or warrant that your use of our
          Services will be uninterrupted, timely, or error-free.
        </p>
        <p>
          We do not warrant that the results that may be obtained from the use
          of the Services will be accurate or reliable.
        </p>
        <p>
          You expressly agree that your use of, or inability to use, the
          Services is at your sole risk. The Services and all products and
          Services delivered to you through the Services are (except as
          expressly stated by us) provided ‘AS IS’ and ‘AS AVAILABLE’ for your
          use, without any representation, warranties, or conditions of any
          kind, either express or implied, including all implied warranties or
          conditions of merchantability, merchantable quality, fitness for a
          particular purpose, durability, title, and non-infringement.
        </p>
        <p>
          In no case shall ALBERTai®, our directors, officers, employees,
          affiliates, agents, contractors, interns, suppliers, service providers
          or licensors are liable for any injury, loss, claim, or any direct,
          indirect, incidental, punitive, special, or consequential damages of
          any kind, including, without limitation lost profits, lost revenue,
          lost savings, loss of data, replacement costs, or any similar damages,
          whether based in contract, tort (including without limitation,
          negligence), strict liability or for any other reason or cause of
          action, arising from your use of any of the Services or any products
          procured using the Services, or for any other claim related in any way
          to your use of the Services or any product, including, but not limited
          to, any errors or omissions in any content or any loss or damage of
          any kind incurred as a result of the use of the Services or any
          content (or product) posted, transmitted, or otherwise made available
          via the Services, even if advised of their possibility. Because some
          states or jurisdictions do not allow the exclusion or the limitation
          of liability for consequential or incidental damages, in such states
          or jurisdictions, our liability shall be limited to the maximum extent
          permitted by law.
        </p>

        <h3>SECTION 9 – INDEMNIFICATION</h3>
        <p>
          You agree to indemnify, defend, and hold harmless Unity Global Care
          Inc® and our subsidiaries, affiliates, partners, officers, directors,
          agents, contractors, licensors, service providers, subcontractors,
          suppliers, interns, and employees, harmless from any claim or demand,
          including reasonable attorneys’ fees, made by any third party due to
          or arising out of your breach of these Terms of Service (including,
          without limitation, any documents or terms incorporated by reference),
          your violation of any law or the rights of a third party and/or any
          action or inaction by you.
        </p>

        <h3>SECTION 10 – SEVERABILITY</h3>
        <p>
          In the event that any provision of these Terms of Service is
          determined to be unlawful, void, or unenforceable, such provision
          shall nonetheless be enforceable to the fullest extent permitted by
          applicable law, and the unenforceable portion shall be deemed to be
          severed from these Terms of Service, such determination shall not
          affect the validity and enforceability of any other remaining
          provisions.
        </p>

        <h3>SECTION 11 – TERMINATION</h3>
        <p>
          The obligations and liabilities of the parties incurred prior to the
          termination date shall survive the termination of this agreement for
          all purposes.
        </p>
        <p>
          These Terms of Service are effective unless and until terminated or
          modified by us.
        </p>
        <p>
          If in our sole judgment, you fail, or we suspect that you have failed,
          to comply with any term or provision of these Terms of Service, we
          also may terminate the Services, if any, provided to you at any time
          without notice and you will remain liable for all amounts due up to
          and including the date of termination; and/or accordingly may deny you
          access to our Services (or any part thereof).
        </p>

        <h3>SECTION 12 – ENTIRE AGREEMENT</h3>
        <p>
          The failure of us to exercise or enforce any right or provision of
          these Terms of Service shall not constitute a waiver of any such
          rights or provision. These Terms of Service and any policies or
          operating rules posted by us on this site or with respect to the
          Services constitute the entire agreement and understanding between you
          and us and govern your use of the Services, superseding any prior or
          contemporaneous agreements, communications, and proposals, whether
          oral or written, between you and us (including, but not limited to,
          any prior versions of the Terms of Service). Notwithstanding the
          foregoing, any written or electronic agreement for specific Services
          shall supersede and amend these Terms of Service.
        </p>
        <p>
          Any ambiguities in the interpretation of these Terms of Service shall
          not be construed against ALBERTai®.
        </p>

        <h3>SECTION 13 – GOVERNING LAW</h3>
        <p>
          These Terms of Service and any separate agreements whereby we provide
          you Services shall be governed by and construed in accordance with the
          laws of Delaware, United States.
        </p>

        <h3>SECTION 14 – CHANGES TO TERMS OF SERVICE</h3>
        <p>
          You can review the most current version of the Terms of Service at any
          time on this page.
        </p>
        <p>
          We reserve the right, at our sole discretion, to update, change, or
          replace any part of these Terms of Service by posting updates and
          changes to our website. It is your responsibility to check our website
          periodically for changes. Your continued use of or access to our
          website or the Services following the posting of any changes to these
          Terms of Service constitutes acceptance of those changes.
        </p>

        <h3>SECTION 15 – CONTACT INFORMATION</h3>
        <p>
          Questions about the Terms of Service should be sent to us at
          info@myalbertai.com.
        </p>
      </div>
      {/* Close main content wrapper */}
    </div>
  );
};

export default TermsOfUse;
